import {
  apiClient,
  type TruckModelImportJobExEntity,
  type PageEntity
} from '@/libs/api'
import { type TruckModelImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTruckModelImportJobsQuery = {
  tenantKey: string
  query: TruckModelImportJobsRequestQuery
}

export type FetchTruckModelImportJobsResponse = {
  data: TruckModelImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTruckModelImportJobs = async (
  { tenantKey, query }: FetchTruckModelImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTruckModelImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_model_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
